import styled from 'styled-components'

const CookiePopupStyle = styled.div`
	--cpMaxWidth: 83.75%;
	--cpBottomPosition: var(--sp5x);
	--cpPaddingH: var(--sp4x);
	--cpPaddingV: var(--sp2x);

	display: flex;
	align-items: center;
	position: fixed;
	left: 50%;
	bottom: var(--cpBottomPosition);
	transform: translate(-50%, 200%);
	width: var(--cpMaxWidth);
	padding: var(--cpPaddingV) var(--cpPaddingH);
	background: var(--primaryColor1);
	color: var(--primaryColor3);
	border-radius: var(--sp2x);
	z-index: 999999999;

	.cp-text {
		margin-right: 10%;

		.cp-read-more {
			text-decoration: underline;
			color: var(--primaryColor2);
			transition: var(--trTime);
			cursor: pointer;

			@media (hover: hover) {
				&:hover {
					color: var(--secondaryColor3);
				}
			}
		}
	}

	.cp-button {
		white-space: nowrap;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeXLMin}) {
		--cpMaxWidth: 83.33%;
		--cpBottomPosition: var(--sp4x);
		--cpPaddingH: var(--sp4x);
		--cpPaddingV: var(--sp2x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeLMin}) {
		--cpMaxWidth: 83.44%;
		--cpBottomPosition: var(--sp4x);
		--cpPaddingH: var(--sp3x);
		--cpPaddingV: var(--sp2x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeMMin}) {
		--cpMaxWidth: 83.33%;
		--cpBottomPosition: var(--sp4x);
		--cpPaddingH: var(--sp4x);
		--cpPaddingV: var(--sp4x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeSMin}) {
		--cpMaxWidth: 83.75%;
		--cpBottomPosition: var(--sp3x);
		--cpPaddingH: var(--sp3x);
		--cpPaddingV: var(--sp3x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeXSMin}) {
		--cpMaxWidth: 87.89%;
		--cpBottomPosition: var(--sp3x);
		--cpPaddingH: var(--sp3x);
		--cpPaddingV: var(--sp2x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.TabletSizeMin}) {
		--cpMaxWidth: 83.85%;
		--cpBottomPosition: var(--sp2x);
		--cpPaddingH: var(--sp3x);
		--cpPaddingV: var(--sp3x);

		flex-direction: column;
		align-items: flex-start;

		.cp-text {
			margin-right: 0;
			margin-bottom: var(--sp3x);
		}
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--cpMaxWidth: 84.39%;
		--cpBottomPosition: var(--sp2x);
		--cpPaddingH: var(--sp3x);
		--cpPaddingV: var(--sp3x);

		flex-direction: column;
		align-items: flex-start;

		.cp-text {
			margin-right: 0;
			margin-bottom: var(--sp3x);
		}
	}
`

export default CookiePopupStyle
